import { jwtDecode } from "jwt-decode";
import { CustomJwtPayload, IUserRoles, } from '../Interfaces/IUserRoles';
import { RoleMapping, RoleList } from '../Services/UserRoleConfig';

// get role from token
export const extractRolesFromJWT = (token: string): string[] => {
    if (!token || typeof token !== "string" || token.trim() === "") {
        return [];
    }

    try {
        const tokenDecoded = jwtDecode(token) as CustomJwtPayload;
        const tokenRoles: string[] = Array.isArray(tokenDecoded?.roles) ? tokenDecoded.roles : [];
        return tokenRoles;
    } catch (error) {
        console.error('Error decoding JWT token');
        return [];
    }
};

// common method to check role has (folder/page) access
export function hasRoleAccess(
    accessKey: string,
    roles: IUserRoles,
    accessConfig: Record<string, RoleList[]> | Record<string, { roles: RoleList[]; order: number }>
): boolean {
    if (!accessKey || !roles) return false;
    const accessValue = accessConfig[accessKey];
    if (!accessValue) return false;
    
    // Check if accessValue has the new structure with roles property
    const allowedRoles = Array.isArray(accessValue) ? accessValue : accessValue.roles;
    return allowedRoles.some(availableRoles => roles[RoleMapping[availableRoles as RoleList]]);
}